import React, { useState } from 'react';
import { TextField, Typography, FormControl, Box } from '@mui/material';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Eye icon import

const InputField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = 'text',
  fullWidth = true,
  required = false,
  error = false,
  helperText = '',
  containerStyles = {},
  icon,
  direction = "ltr",
  t,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  // Toggle password visibility
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <FormControl fullWidth >
      <Box sx={{ mt: '16px', mb: '8px', ...containerStyles }}>
        <Box
          sx={{
            display: 'flex',

            flexDirection: direction === "rtl" ? 'row-reverse' : 'row', // Reverse for RTL
            justifyContent: direction === "rtl" ? 'flex-start' : '', // Adjust justify for RTL
          }}
        >
          {icon && (
            <Box
              sx={{
                marginLeft: direction ? '4px' : '0',
                marginRight: direction ? '' : '',
                fontSize: "16px"
              }}
            >
              {icon}
            </Box>
          )}
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#676464',
              lineHeight: '16.41px',
              textAlign: direction === "rtl" ? 'right' : 'left',
            }}
          >
            {label}
          </Typography>

          {required && (
            <Typography
              sx={{
                color: '#CA0B0B',
                fontWeight: 700,
                mt: '-18px',
                ml: direction ? '3px' : undefined, // Adjust margins for RTL
                mr: direction ? undefined : '3px', // Adjust margins for RTL
                fontSize: '20px',
              }}
            >
              *
            </Typography>
          )}
        </Box>

        <TextField
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          fullWidth
          variant="outlined"
          placeholder={placeholder}
          type={type === 'password' && !showPassword ? 'password' : 'text'} // Toggle password visibility

          error={error}
          helperText={error && helperText}
          sx={{
            borderRadius: '10px',
            textAlign: direction === "rtl" ? 'right' : 'left', // Align input text to the right for RTL
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
            },
            '& .MuiInputBase-input': {
              color: '#12538B',
              direction: direction === "rtl" ? 'rtl' : 'ltr', // Set input direction based on RTL
            },
            '& .MuiInputBase-input::placeholder': {
              color: '#AFACAC',
              fontSize: "14px"
            },
          }}

          InputProps={{
            style: {
              borderRadius: '10px',
            },
            startAdornment: direction === "rtl" && type === 'password' && (
              <Box
              sx={{
                cursor: 'pointer',
                fontSize: '20px',
                color: '#676464',
                marginLeft:" 10px",
                transform: 'translateX(-50%)', // Adjust for proper centering
              }}
                onClick={handleTogglePassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Show icon at start for RTL */}
              </Box>
            ),
            endAdornment: direction !== "rtl" && type === 'password' && (
              <Box
              sx={{
                cursor: 'pointer',
                fontSize: '20px',
                color: '#676464',
                marginRight:" 10px",
                transform: 'translateX(50%)', // Adjust for proper centering
              }}
                onClick={handleTogglePassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Show icon at end for LTR */}
              </Box>
            ),
          }}
          {...props}
        />
      </Box>
    </FormControl>
  );
};

export default InputField;
